import React, { useState, useEffect } from "react";
import styles from "./HomePage.module.css";
import FinancialMarkets from "./financialMarket/financialMarket";
import ClientFundInsurance from "./client/client";
import AboutFXCTRUMMarkets from "./clientAbout/clientAbout";
import TailoredToMatch from "./trade/trade";
import TradeAndManage from "./tailored/tailored";
import AccountTypes from "./accountType/accountType"; 
import TradingSpreads from '../../components/TradingSpreads/TradingSpreads';
import NewsCarousel from '../../components/NewsCarousel/NewsCarousel';

// Carousel images
import carouselImage1 from "../../assets/trading_desk.jpg";
import carouselImage2 from "../../assets/stock_chart.jpg";
import carouselImage3 from "../../assets/global_market.jpg";
import carouselImage4 from "../../assets/mobile_trading.jpg";

const images = [
  {
    src: carouselImage1,
    alt: "Modern trading desk with multiple monitors",
    caption: "Stay Connected to Global Markets, 24/7",
  },
  {
    src: carouselImage2,
    alt: "Detailed stock chart with candlestick patterns",
    caption: "Visualize Trends with Advanced Interactive Charts",
  },
  {
    src: carouselImage3,
    alt: "Panoramic view of a bustling financial district at sunset",
    caption: "Harness the Power of Real-time Market Data",
  },
  {
    src: carouselImage4,
    alt: "Person using a mobile trading app on a smartphone",
    caption: "Trade Anytime, Anywhere with Our Intuitive Mobile Platform",
  },
];

function HomePage() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    // Verify images array is valid
    if (images && images.length > 0) {
      setImagesLoaded(true);
      
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 4000);
      
      return () => clearInterval(interval);
    }
  }, []);

  // Handle URL hash navigation (for direct links to sections)
  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const headerHeight = 70;
          const elementPosition = element.offsetTop - headerHeight;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, []);

  // Show loading if images aren't ready
  if (!imagesLoaded || !images || images.length === 0) {
    return (
      <div className={styles.homePage}>
        <div className={styles.loadingScreen}>
          <div className={styles.loadingContent}>
            <div className={styles.loadingSpinner}></div>
            <h2>Loading StoneForex Platform...</h2>
            <p>Preparing your trading environment</p>
          </div>
        </div>
        
        {/* Load sections with IDs even during loading */}
        <div id="markets"><FinancialMarkets /></div>
        <div id="accounts"><AccountTypes /></div>
        <div id="services">
          <ClientFundInsurance />
          <TailoredToMatch />
        </div>
        <TradingSpreads />
        <div id="news"><NewsCarousel /></div> {/* 👈 News goes to NewsCarousel */}
        <div id="education"><TradeAndManage /></div>
        <div id="about"><AboutFXCTRUMMarkets /></div>
      </div>
    );
  }

  // Get current image safely
  const currentImage = images[currentImageIndex] || images[0];

  return (
    <div className={styles.homePage}>
      {/* Hero Section with Safe Image Rendering */}
      <section className={styles.heroSection}>
        <div className={styles.carouselContainer}>
          {currentImage && currentImage.src && (
            <>
              <img
                src={currentImage.src}
                alt={currentImage.alt}
                className={styles.carouselImage}
                onError={(e) => {
                  // Fallback if image fails to load
                  e.target.src = "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=1200&h=600&fit=crop";
                }}
              />
              <div className={styles.carouselCaption}>
                <p>{currentImage.caption}</p>
              </div>
            </>
          )}
          
          {/* Carousel Indicators */}
          <div className={styles.carouselIndicators}>
            {images.map((_, index) => (
              <div
                key={index}
                className={`${styles.indicator} ${
                  index === currentImageIndex ? styles.active : ""
                }`}
                onClick={() => setCurrentImageIndex(index)}
              ></div>
            ))}
          </div>
        </div>

        <div className={styles.heroContentContainer}>
          <div className={styles.heroContent}>
            <h1>Master the <span>Financial Markets</span></h1>
            <p className={styles.tagline}>
              Access powerful trading tools, real-time market data, and expert analysis. 
              From forex to cryptocurrencies, trade with confidence using our 
              award-winning platform trusted by thousands of active traders worldwide.
            </p>
            <div className={styles.callToAction}>
              <button className={styles.primaryButton}>
                Start Trading Now
              </button>
              <button className={styles.secondaryButton}>
                Try Demo Account
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Sections with Correct IDs */}
      <div id="markets">
        <FinancialMarkets /> {/* 👈 Markets button scrolls here */}
      </div>
      
      <div id="accounts">
        <AccountTypes /> {/* 👈 Accounts button scrolls here */}
      </div>
      
      <div id="services">
        <ClientFundInsurance /> {/* 👈 Services button scrolls here */}
        <TailoredToMatch />
      </div>
      
      {/* Trading Spreads - No navigation button, just part of the flow */}
      <TradingSpreads />
      
      <div id="news">
        <NewsCarousel /> {/* 👈 News button scrolls here (Financial News) */}
      </div>
      
      <div id="education">
        <TradeAndManage /> {/* 👈 Education button scrolls here */}
      </div>
      
      <div id="about">
        <AboutFXCTRUMMarkets /> {/* 👈 About Us button scrolls here */}
      </div>
    </div>
  );
}

export default HomePage;
